const transformNewsletter = ({ auto_open , disabled_paths , fields , open_timeout , visited_before_open , image  })=>({
        autoOpen: auto_open,
        openTimeout: open_timeout,
        disabledPaths: disabled_paths.map((item)=>item.path),
        fields: transformNewsletterFields(fields),
        image: {
            src: image?.src,
            originalWidth: image?.width,
            originalHeight: image?.height
        },
        showPopupInPageViewed: visited_before_open
    });
const transformNewsletterFields = ({ firstname , lastname , dob , gender , country , phone , collections  })=>({
        firstname,
        lastname,
        dob,
        gender: {
            enabled: gender.enabled,
            required: gender.required,
            values: gender.list
        },
        country,
        telephone: phone,
        collections: {
            enabled: collections.enabled,
            required: collections.required,
            values: collections.list
        }
    });
const transformCountries = (data)=>data.map(({ label , code , regions  })=>({
            label,
            code,
            regions
        }));
const transformCoreStoresLanguages = (data)=>data.map(({ name , code , locale  })=>({
            name,
            store: code,
            locale: locale.code.replace('_', '-')
        }));
const transformCoreStoresStore = ({ code , marketplace  })=>({
        code,
        groupName: marketplace
    });
const transformClerkAttributes = ({ facetsAttributes , titles  })=>{
    try {
        const parsedTitles = JSON.stringify(Object.keys(JSON.parse(titles)));
        return parsedTitles || JSON.stringify(facetsAttributes.split(','));
    } catch (e) {
        try {
            return JSON.stringify(facetsAttributes.split(','));
        } catch (e) {
            return null;
        }
    }
};
const transformClerkTitles = ({ facetsTitles  })=>{
    const sortBy = (arr, fn)=>arr.sort((a, b)=>{
            const fa = fn(a);
            const fb = fn(b);
            if (fa < fb) return -1;
            if (fa > fb) return 1;
            return 0;
        });
    try {
        const titles = JSON.parse(facetsTitles);
        const sortedTitles = JSON.stringify(sortBy(Object.entries(titles), ([, value])=>value.sort_order).map(([key, value])=>({
                [key]: value.label || key
            })).reduce((acc, item)=>({
                ...acc,
                ...item
            }), {}));
        return sortedTitles;
    } catch (e) {
        return `[]`;
    }
};
const transformPartnerProgramFormFields = (_fields)=>{
    const MANDATORY_FORM_FIELDS = [
        'firstname',
        'lastname',
        'email',
        // only if 'email_confirmation_enabled' is true
        'emailConfirm',
        'password',
        'passwordConfirm'
    ];
    const fields = [];
    Object.keys(_fields || {}).forEach((key)=>{
        // get last occurrence of '_' and remove the last part of the string
        const name = key.replace(/_[^_]*$/, '');
        // get the last part of the string (after the last '_')
        const type = key.replace(/^.*_/, '') // enabled, required, sortorder, fields
        ;
        if (name === 'email_confirmation') {
            return;
        }
        const values = type === 'fields' ? Object.entries(_fields[key] || []).map(([, value])=>{
            const key = name.replace('_', '');
            return {
                label: value[`${key}label`],
                value: value[`${key}value`]
            };
        }) : [];
        const field = fields.find((field)=>field.name === name);
        if (field) {
            if (type === 'fields') {
                field.values = values;
            } else {
                if (type === 'sortorder') {
                    field.order = parseInt(_fields[key] || 0);
                } else {
                    field[type] = _fields[key];
                }
            }
        } else {
            fields.push({
                name,
                [type]: _fields[key],
                values
            });
        }
    });
    // sort fields by order
    fields.filter(({ enabled  })=>enabled).sort((a, b)=>a.order - b.order);
    let index = -MANDATORY_FORM_FIELDS.length;
    const formFields = MANDATORY_FORM_FIELDS.map((field)=>{
        if (field === 'emailConfirm' && !_fields?.email_confirmation_enabled) {
            return;
        }
        return {
            name: field,
            enabled: true,
            required: true,
            order: index++,
            values: []
        };
    });
    // mandatory fields are always first
    return formFields.concat(fields);
};
const transformCoreStoresResponse = ({ metadata  })=>metadata?.storefrontConfig ? {
        siteName: metadata?.storefrontConfig?.general?.site_name,
        siteTelephone: metadata?.storefrontConfig?.general?.site_telephone,
        logo: {
            light: {
                image: metadata?.storefrontConfig?.logo?.light?.image,
                width: metadata?.storefrontConfig?.logo?.light?.width,
                height: metadata?.storefrontConfig?.logo?.light?.height
            },
            dark: {
                image: metadata?.storefrontConfig?.logo?.dark?.image,
                width: metadata?.storefrontConfig?.logo?.dark?.width,
                height: metadata?.storefrontConfig?.logo?.dark?.height
            }
        },
        fonts: metadata?.storefrontConfig?.fonts,
        favicon: metadata?.storefrontConfig?.content?.html_head?.favicon,
        suggestedStore: {
            enabled: metadata?.storefrontConfig?.geoip?.misfits,
            template: metadata?.storefrontConfig?.geoip?.suggested_store?.template
        },
        internalServerError: {
            bgImage: metadata?.storefrontConfig?.internal_server_error?.bg_image,
            bgImageMobile: metadata?.storefrontConfig?.internal_server_error?.bg_image_mobile
        },
        noRoute: {
            bgImage: metadata?.storefrontConfig?.no_route?.bg_image,
            bgImageMobile: metadata?.storefrontConfig?.no_route?.bg_image_mobile
        },
        googleRecaptcha: {
            enabled: metadata?.storefrontConfig?.google_recaptcha?.enabled,
            siteKey: metadata?.storefrontConfig?.google_recaptcha?.site_key
        },
        maintenance: {
            enabled: metadata?.storefrontConfig?.maintenance?.enabled,
            allowedUrls: metadata?.storefrontConfig?.maintenance?.allowed_urls_list,
            allowedIps: metadata?.storefrontConfig?.maintenance?.allowed_ips_list,
            pageTitle: metadata?.storefrontConfig?.maintenance?.page_title,
            bgImage: `${metadata?.storefrontConfig?.maintenance?.bg_image}`,
            frontText: metadata?.storefrontConfig?.maintenance?.front_text,
            bgImageMobile: metadata?.storefrontConfig?.maintenance?.bg_image_mobile
        },
        seoMeta: {
            title: metadata?.storefrontConfig?.content?.html_head?.default_title || '',
            keywords: metadata?.storefrontConfig?.content?.html_head?.meta_keywords || '',
            titlePrefix: metadata?.storefrontConfig?.content?.html_head?.title_prefix || '',
            titleSuffix: metadata?.storefrontConfig?.content?.html_head?.title_suffix || '',
            description: metadata?.storefrontConfig?.content?.html_head?.meta_description || '',
            robots: metadata?.storefrontConfig?.content?.search_engine_robots?.default_robots,
            thumbnail: metadata?.storefrontConfig?.seo?.serp_thumbnail
        },
        headHtml: metadata?.storefrontConfig?.content?.html_head?.include_script,
        footerHtml: metadata?.storefrontConfig?.content?.footer?.misc_html,
        footerBar: {
            enabled: metadata?.storefrontConfig?.footer_bar?.enabled,
            cmsBlockIdentifier: metadata?.storefrontConfig?.footer_bar?.cms_block_identifier
        },
        demoNotice: metadata?.storefrontConfig?.content?.html_head?.demonotice,
        pageLoader: {
            enabled: metadata?.storefrontConfig?.general?.page_loader?.enabled,
            timeout: metadata?.storefrontConfig?.general?.page_loader?.timeout
        },
        images: {
            format: metadata?.storefrontConfig?.images?.format,
            quality: metadata?.storefrontConfig?.images?.quality,
            placeholder: metadata?.storefrontConfig?.images?.placeholder,
            spinnerPlaceholder: metadata?.storefrontConfig?.images?.spinner_placeholder,
            responsiveSizes: metadata?.storefrontConfig?.images?.responsive_sizes
        },
        cart: {
            allowEmptyCartButton: metadata?.storefrontConfig?.cart?.allow_empty_cart,
            backOrderChip: {
                color: metadata?.storefrontConfig?.cart?.back_order?.chip?.color,
                textColor: metadata?.storefrontConfig?.cart?.back_order?.chip?.text_color
            },
            freeGifts: {
                salesRuleId: metadata?.storefrontConfig?.cart?.free_gifts?.sales_rule_id,
                slider: {
                    slidesPerView: metadata?.storefrontConfig?.cart?.free_gifts?.slider?.slides_per_view
                }
            },
            freeItemChip: {
                color: metadata?.storefrontConfig?.cart?.free_gifts?.chip?.color,
                textColor: metadata?.storefrontConfig?.cart?.free_gifts?.chip?.text_color
            },
            crossSell: {
                slider: {
                    slidesPerView: metadata?.storefrontConfig?.cart?.crosssell?.slider?.slides_per_view
                }
            },
            coupon: {
                expanded: metadata?.storefrontConfig?.cart?.coupon?.expanded
            },
            showFreeShipping: metadata?.storefrontConfig?.cart?.show_free_shipping ?? false
        },
        checkout: {
            disableGuest: metadata?.storefrontConfig?.sales?.checkout?.general?.disable_guest ?? false,
            shippingMethods: {
                pickUpInStore: {
                    enabled: metadata?.storefrontConfig?.sales?.checkout?.pickup_in_store?.enabled ?? false,
                    externalPickUpServices: metadata?.storefrontConfig?.sales?.checkout?.external_pickup_services?.map(({ id , enabled , title  } = {})=>({
                            id,
                            enabled,
                            title
                        })) ?? []
                }
            },
            termsAndConditions: {
                enabled: !metadata?.storefrontConfig?.sales?.checkout?.disable_terms_and_conditions,
                disclaimers: metadata?.storefrontConfig?.general?.disclaimers?.terms_and_conditions ?? ''
            },
            invoice: {
                enabled: metadata?.storefrontConfig?.sales.checkout?.invoice?.enabled,
                mandatory: metadata?.storefrontConfig?.sales.checkout.invoice?.config?.default?.mandatory ?? null,
                fields: Object.entries(metadata?.storefrontConfig?.sales.checkout?.invoice?.config?.default?.fields ?? {}).map(([key, { required  }])=>({
                        name: key,
                        required
                    })),
                countriesConfig: Object.entries(metadata?.storefrontConfig?.sales.checkout?.invoice?.config ?? {}).filter(([country])=>country !== 'default').reduce((acc, [country, { mandatory , fields  }])=>{
                    return {
                        ...acc,
                        [country]: {
                            mandatory,
                            fields: Object.entries(fields ?? {}).map(([key, { required  }])=>({
                                    name: key,
                                    required
                                }))
                        }
                    };
                }, {}),
                externalVatValidationEnabled: metadata?.storefrontConfig?.sales.checkout?.invoice?.external_vat_validation_enabled ?? false,
                taxSeparationEnabled: metadata?.storefrontConfig?.sales.checkout?.invoice?.tax_separation_enabled ?? false
            },
            success: {
                cmsBlockIdentifierTop: metadata?.storefrontConfig?.sales?.checkout?.cms_block_identifier_top ?? 'checkout_success_top',
                cmsBlockIdentifierBottom: metadata?.storefrontConfig?.sales?.checkout?.cms_block_identifier_bottom ?? 'checkout_success_bottom'
            },
            express: {
                editableMissingAddressFields: {
                    shipping: metadata?.storefrontConfig?.sales?.checkout?.express?.editableMissingAddressFields?.shipping ?? [
                        'telephone',
                        'regionText'
                    ],
                    billing: metadata?.storefrontConfig?.sales?.checkout?.express?.editableMissingAddressFields?.billing ?? [
                        'telephone',
                        'regionText'
                    ]
                }
            },
            payByLink: {
                enabled: metadata?.storefrontConfig?.sales?.checkout?.pay_by_link?.enabled ?? false
            }
        },
        sales: {
            giftCards: {
                enabled: metadata?.storefrontConfig?.sales?.gift_cards?.enabled
            },
            giftOptions: {
                giftMessage: {
                    enabled: metadata?.storefrontConfig?.sales?.gift_message?.enabled,
                    messageMaxLength: metadata?.storefrontConfig?.sales?.gift_message?.max_length
                },
                giftWrap: {
                    enabled: metadata?.storefrontConfig?.sales?.gift_wrap?.enabled,
                    imageWidth: metadata?.storefrontConfig?.sales?.gift_wrap?.image_width,
                    imageHeight: metadata?.storefrontConfig?.sales?.gift_wrap?.image_height,
                    livStick: {
                        enabled: metadata?.storefrontConfig?.sales?.gift_wrap?.refilo_livstick?.enabled ?? false,
                        apiKey: metadata?.storefrontConfig?.sales?.gift_wrap?.refilo_livstick?.api_key ?? null,
                        scriptUrl: metadata?.storefrontConfig?.sales?.gift_wrap?.refilo_livstick?.script_url ?? null
                    }
                }
            },
            payments: {
                klarna: {
                    enabled: metadata?.storefrontConfig?.sales?.payments?.klarna?.enabled,
                    clientId: metadata?.storefrontConfig?.sales?.payments?.klarna?.client_id,
                    placementScriptUrl: metadata?.storefrontConfig?.sales?.payments?.klarna?.script_url ?? 'https://eu-library.klarnaservices.com/lib.js',
                    scriptUrl: metadata?.storefrontConfig?.sales?.payments?.klarna?.payment_api ?? 'https://x.klarnacdn.net/kp/lib/v1/api.js',
                    product: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.klarna?.product?.enabled,
                        placement: metadata?.storefrontConfig?.sales?.payments?.klarna?.product?.placement
                    },
                    cart: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.klarna?.cart?.enabled,
                        placement: metadata?.storefrontConfig?.sales?.payments?.klarna?.cart?.placement
                    },
                    includeAddressData: metadata?.storefrontConfig?.sales?.payments?.klarna?.include_address_data ?? false
                },
                scalapay: {
                    enabled: metadata?.storefrontConfig?.sales?.payments?.scalapay?.active,
                    scriptUrl: 'https://cdn.scalapay.com/js/scalapay-widget/scalapay-widget.js',
                    min: parseFloat(metadata?.storefrontConfig?.sales?.payments?.scalapay?.min) || 5,
                    max: parseFloat(metadata?.storefrontConfig?.sales?.payments?.scalapay?.max) || 300,
                    installments: metadata?.storefrontConfig?.sales?.payments?.scalapay?.installments ?? 3,
                    product: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.scalapay?.product?.active ?? false,
                        size: '100%',
                        logoSize: '100%',
                        logoAlignment: -6,
                        logoColor: '#000000',
                        priceColor: '#000000',
                        hideLogo: false,
                        hidePrice: false
                    },
                    cart: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.scalapay?.cart?.active ?? false,
                        size: '100%',
                        logoSize: '100%',
                        logoAlignment: -6,
                        logoColor: '#000000',
                        priceColor: '#000000',
                        hideLogo: false,
                        hidePrice: false
                    }
                },
                paypal: {
                    enabled: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.active ?? false,
                    expressCheckout: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.express_checkout_active,
                        minicart: {
                            enabled: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.express_checkout_minicart_enabled ?? true
                        },
                        cart: {
                            enabled: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.express_checkout_cart_enabled ?? true
                        }
                    },
                    clientId: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.client_id,
                    scriptUrl: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.script_url ?? 'https://www.paypal.com/sdk/js',
                    color: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.color,
                    layout: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.layout,
                    tagline: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.tagline,
                    product: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.product_enabled ?? false
                    },
                    cart: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.filoblu_paypal?.cart_enabled ?? false
                    }
                },
                adyen: {
                    mode: metadata?.storefrontConfig?.sales?.payments?.adyen?.mode,
                    sdkVersion: metadata?.storefrontConfig?.sales?.payments?.adyen?.js_sdk_version,
                    js: metadata?.storefrontConfig?.sales?.payments?.adyen?.[`js_${metadata?.storefrontConfig?.sales?.payments?.adyen?.mode}`],
                    css: metadata?.storefrontConfig?.sales?.payments?.adyen?.[`css_${metadata?.storefrontConfig?.sales?.payments?.adyen?.mode}`],
                    jsIntegrityHash: metadata?.storefrontConfig?.sales?.payments?.adyen?.js_integrity_hash,
                    cssIntegrityHash: metadata?.storefrontConfig?.sales?.payments?.adyen?.css_integrity_hash,
                    merchantAccount: metadata?.storefrontConfig?.sales?.payments?.adyen?.merchant_account,
                    clientKey: metadata?.storefrontConfig?.sales?.payments?.adyen?.client_key,
                    keyType: metadata?.storefrontConfig?.sales?.payments?.adyen?.key_type,
                    card: metadata?.storefrontConfig?.sales?.payments?.adyen?.cc
                },
                banktransfer: {
                    instruction: metadata?.storefrontConfig?.sales?.payments?.banktransfer?.instruction
                },
                amazonpay: {
                    enabled: metadata?.storefrontConfig?.sales?.payments?.amazonpay?.enabled,
                    js: metadata?.storefrontConfig?.sales?.payments?.amazonpay?.js_script_url,
                    minicart: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.amazonpay?.minicart?.enabled
                    },
                    cart: {
                        enabled: metadata?.storefrontConfig?.sales?.payments?.amazonpay?.cart?.enabled
                    }
                }
            },
            coupon: {
                disabled: metadata?.storefrontConfig?.sales?.coupon?.disabled ?? false
            }
        },
        storelocator: {
            template: metadata?.storefrontConfig?.storelocator?.template,
            autocomplete: {
                enabled: metadata?.storefrontConfig?.storelocator?.autocomplete?.enabled,
                type: metadata?.storefrontConfig?.storelocator?.autocomplete?.type,
                zoom: metadata?.storefrontConfig?.storelocator?.autocomplete?.zoom
            },
            details: metadata?.storefrontConfig?.storelocator?.details.enabled,
            storeDetailsPath: metadata?.storefrontConfig?.storelocator?.details.path || '/storelocator/detail/id/',
            enabled: metadata?.storefrontConfig?.storelocator?.enabled,
            availabilityInStore: {
                enabled: metadata?.storefrontConfig?.storelocator?.product_in_store?.enable_product_in_store,
                hideNotAvailables: metadata?.storefrontConfig?.storelocator?.product_in_store?.hide_not_availables
            },
            map: {
                defaultCenter: metadata?.storefrontConfig?.storelocator?.map?.default_center_coordinates,
                defaultZoom: metadata?.storefrontConfig?.storelocator?.map?.default_zoom,
                options: {
                    maxZoom: metadata?.storefrontConfig?.storelocator?.map?.max_zoom,
                    minZoom: metadata?.storefrontConfig?.storelocator?.map?.min_zoom,
                    styles: JSON.parse(metadata?.storefrontConfig?.storelocator?.map?.style || '[]'),
                    type: metadata?.storefrontConfig?.storelocator?.map?.type,
                    //map controls
                    rotateControl: metadata?.storefrontConfig?.storelocator?.map?.controls?.rotate,
                    scaleControl: metadata?.storefrontConfig?.storelocator?.map?.controls?.scale,
                    streetViewControl: metadata?.storefrontConfig?.storelocator?.map?.controls?.street_view,
                    mapTypeControl: metadata?.storefrontConfig?.storelocator?.map?.controls?.map_type,
                    fullscreenControl: metadata?.storefrontConfig?.storelocator?.map?.controls?.fullscreen,
                    zoomControl: metadata?.storefrontConfig?.storelocator?.map?.controls?.zoom
                }
            },
            baiduMap: {
                // TODO: missing configs
                defaultCenter: {
                    lat: 41.068179,
                    lng: 14.331737
                },
                /* metadata?.storefrontConfig?.storelocator?.baidu_map?.default_center_coordinates ??
						metadata?.storefrontConfig?.storelocator?.map?.default_center_coordinates, */ defaultZoom: 13,
                /* metadata?.storefrontConfig?.storelocator?.baidu_map?.default_zoom ??
							metadata?.storefrontConfig?.storelocator?.map?.default_zoom, */ // https://lbsyun.baidu.com/customv2/editor/nostyleid
                styles: [],
                type: 'normal',
                //map controls
                controls: {
                    navigationControl: true,
                    // metadata?.storefrontConfig?.storelocator?.baidu_map?.controls?.navigation_enabled ?? true,
                    scaleControl: false,
                    overviewMapControl: false,
                    // metadata?.storefrontConfig?.storelocator?.baidu_map?.controls?.overview_enabled ?? false,
                    mapTypeControl: metadata?.storefrontConfig?.storelocator?.baidu_map?.controls?.map_type_enabled ?? false,
                    geolocationControl: true
                }
            },
            geolocation: {
                directions: metadata?.storefrontConfig?.storelocator?.geolocation?.directions,
                distance: metadata?.storefrontConfig?.storelocator?.geolocation?.distance,
                enabled: metadata?.storefrontConfig?.storelocator?.geolocation?.enabled,
                travelMode: metadata?.storefrontConfig?.storelocator?.geolocation?.travel_mode,
                zoom: metadata?.storefrontConfig?.storelocator?.geolocation?.zoom
            },
            marker: {
                clusterImage: metadata?.storefrontConfig?.storelocator?.marker?.cluster_image,
                image: metadata?.storefrontConfig?.storelocator?.marker?.image
            },
            tags: {
                enabled: metadata?.storefrontConfig?.storelocator?.tags?.enabled
            },
            useVirtualList: metadata?.storefrontConfig?.storelocator?.use_virtual_list,
            path: metadata?.storefrontConfig?.storelocator?.path || '/storelocator/',
            seoMeta: {
                title: metadata?.storefrontConfig?.storelocator?.seo_meta?.title,
                description: metadata?.storefrontConfig?.storelocator?.seo_meta?.description,
                robots: metadata?.storefrontConfig?.storelocator?.seo_meta?.robots,
                keywords: metadata?.storefrontConfig?.storelocator?.seo_meta?.keywords || ''
            },
            nearbyStores: {
                enabled: metadata?.storefrontConfig?.storelocator?.nearby_stores?.enabled,
                limit: metadata?.storefrontConfig?.storelocator?.nearby_stores?.limit
            }
        },
        googleMaps: {
            apiKey: metadata?.storefrontConfig?.google_maps?.key,
            libraries: metadata?.storefrontConfig?.google_maps?.libraries
        },
        baidu: {
            // TODO: missing configs
            enabled: false,
            apiKey: '',
            autocomplete: {
                enabled: false,
                /* metadata?.storefrontConfig?.baidu?.autocomplete?.enabled ||
							metadata?.storefrontConfig?.storelocator?.autocomplete?.enabled, */ types: []
            }
        },
        groupName: metadata?.storefrontConfig?.general?.marketplace,
        defaultCurrency: metadata?.storefrontConfig?.general?.default_currency,
        displayCurrencies: metadata?.storefrontConfig?.general?.display_currencies,
        price: {
            showPercentage: metadata?.storefrontConfig?.general?.price?.show_percentage,
            /**
					 * default is got from the default formatting of the currency
					 * left is the currency symbol on the left side of the price
					 * right is the currency symbol on the right side of the price
					 */ currencyPosition: metadata?.storefrontConfig?.general?.price?.currency_position,
            attributeCode: metadata?.storefrontConfig?.general?.price?.attribute_code,
            filterVariant: metadata?.storefrontConfig?.general?.price?.filter_variant,
            modeDefault: metadata?.storefrontConfig?.general?.price?.mode_default,
            modeTiles: metadata?.storefrontConfig?.general?.price?.mode_tiles,
            /**
					 * use intlOptions to customize on project the options passed to Intl.NumberFormat
					 */ intlNumberFormatOptions: {}
        },
        locale: metadata?.storefrontConfig?.general?.locale?.code?.replace('_', '-'),
        flagsShape: metadata?.storefrontConfig?.flags_shape || 'round',
        catalog: {
            urlKeySuffix: metadata?.storefrontConfig?.catalog?.url_key_suffix,
            vatLabel: metadata?.storefrontConfig?.catalog?.vat_label,
            cartVatLabel: metadata?.storefrontConfig?.catalog?.cart_vat_label,
            staticPath: metadata?.storefrontConfig?.catalog?.not_seo_friendly_urls,
            products: {
                images: {
                    width: metadata?.storefrontConfig?.catalog?.products?.image_size.width,
                    height: metadata?.storefrontConfig?.catalog?.products?.image_size.height
                },
                placeholder: metadata?.storefrontConfig?.catalog?.products?.placeholder,
                oosNotification: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.enable_oos_notifications,
                    newsletter: metadata?.storefrontConfig?.catalog?.products?.enable_oos_notifications_newsletter
                },
                outOfStockChip: {
                    color: metadata?.storefrontConfig?.catalog?.products?.out_of_stock?.chip_color,
                    textColor: metadata?.storefrontConfig?.catalog?.products?.out_of_stock?.chip_text_color
                },
                rating: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.rating,
                    guest: metadata?.storefrontConfig?.catalog?.products?.rating_guest,
                    slider: {
                        slidesPerView: metadata?.storefrontConfig?.catalog?.products?.rating_slider_slides_per_view
                    }
                },
                recentlyViewed: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.enable_recently_viewed_products,
                    limit: metadata?.storefrontConfig?.catalog?.products?.max_recently_viewed_products,
                    slider: {
                        slidesPerView: metadata?.storefrontConfig?.catalog?.products?.recently_views_slides_per_view
                    }
                },
                related: {
                    slider: {
                        slidesPerView: metadata?.storefrontConfig?.catalog?.products?.related_views_slides_per_view
                    }
                },
                upsells: {
                    slider: {
                        slidesPerView: metadata?.storefrontConfig?.catalog?.products?.upsells_views_slides_per_view
                    }
                },
                ssr: {
                    related: metadata?.storefrontConfig?.catalog?.products?.ssr?.related,
                    upsells: metadata?.storefrontConfig?.catalog?.products?.ssr?.upsells,
                    reviews: metadata?.storefrontConfig?.catalog?.products?.ssr?.reviews,
                    configurableChildrenProducts: metadata?.storefrontConfig?.catalog?.products?.ssr?.configurable_children_products,
                    groupedChildrenProducts: metadata?.storefrontConfig?.catalog?.products?.ssr?.grouped_children_products,
                    bundleChildrenProducts: metadata?.storefrontConfig?.catalog?.products?.ssr?.bundle_children_products
                },
                gallery: metadata?.storefrontConfig?.catalog?.products?.gallery,
                mosaic: {
                    columns: metadata?.storefrontConfig?.catalog?.products?.mosaic?.columns,
                    columnsGap: metadata?.storefrontConfig?.catalog?.products?.mosaic?.columns_gap,
                    rowsGap: metadata?.storefrontConfig?.catalog?.products?.mosaic?.rows_gap
                },
                slider: {
                    navigation: {
                        enabled: metadata?.storefrontConfig?.catalog?.products?.slider?.navigation?.enabled
                    },
                    pagination: {
                        enabled: metadata?.storefrontConfig?.catalog?.products?.slider?.pagination?.enabled
                    }
                },
                sliderThumbs: {
                    thumbs: {
                        width: metadata?.storefrontConfig?.catalog?.products?.slider_thumbs?.thumbs?.width,
                        height: metadata?.storefrontConfig?.catalog?.products?.slider_thumbs?.thumbs?.height
                    }
                },
                verticalThumbs: {
                    rowsGap: metadata?.storefrontConfig?.catalog?.products?.vertical_thumbs?.thumbs?.rows_gap,
                    thumbs: {
                        width: metadata?.storefrontConfig?.catalog?.products?.vertical_thumbs?.thumbs?.width,
                        height: metadata?.storefrontConfig?.catalog?.products?.vertical_thumbs?.thumbs?.height
                    }
                },
                zoom: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.zoom?.enabled,
                    thumbs: {
                        enabled: metadata?.storefrontConfig?.catalog?.products?.zoom?.thumbs?.enabled,
                        width: metadata?.storefrontConfig?.catalog?.products?.zoom?.thumbs?.width,
                        height: metadata?.storefrontConfig?.catalog?.products?.zoom?.thumbs?.height
                    }
                },
                attributesMapping: {
                    collection: metadata?.storefrontConfig?.catalog?.products?.attribute_mapping?.collection,
                    brand: metadata?.storefrontConfig?.catalog?.products?.attribute_mapping?.brand,
                    size: metadata?.storefrontConfig?.catalog?.products?.attribute_mapping?.size,
                    sizeGuide: metadata?.storefrontConfig?.catalog?.products?.attribute_mapping?.size_guide
                },
                optionsColumns: metadata?.storefrontConfig?.catalog?.products?.options_columns,
                serviceInfo: metadata?.storefrontConfig?.catalog?.products?.service_info,
                needHelpLink: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.need_help_link?.enabled
                },
                showQty: metadata?.storefrontConfig?.catalog?.products?.show_quantity,
                stickyAddToCart: metadata?.storefrontConfig?.catalog?.products?.sticky_add_to_cart,
                grouped: {
                    showCheckbox: metadata?.storefrontConfig?.catalog?.products?.grouped?.show_check_box
                },
                prevNext: metadata?.storefrontConfig?.catalog?.products?.prev_next,
                stickyBox: metadata?.storefrontConfig?.catalog?.products?.sticky_box,
                relatedAttributes: metadata?.storefrontConfig?.catalog?.products?.related_attributes,
                sidebar: {
                    accordion: metadata?.storefrontConfig?.catalog?.products?.sidebar?.accordion
                },
                features: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.features?.enabled,
                    attributes: metadata?.storefrontConfig?.catalog?.products?.features?.attributes
                },
                comparable: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.enable_product_compare,
                    limit: metadata?.storefrontConfig?.catalog?.products?.max_comparable_products,
                    attributes: metadata?.storefrontConfig?.catalog?.products?.comparable_attributes.split(',') || []
                },
                imageType: {
                    catalogBase: metadata?.storefrontConfig?.catalog?.products?.image_type?.catalog_base,
                    catalogHover: metadata?.storefrontConfig?.catalog?.products?.image_type?.catalog_hover,
                    serviceBase: metadata?.storefrontConfig?.catalog?.products?.image_type?.service_base
                },
                additionalLabel: {
                    attributeCode: metadata?.storefrontConfig?.catalog?.products?.additional_label?.attribute_code,
                    color: metadata?.storefrontConfig?.catalog?.products?.additional_label?.color,
                    textColor: metadata?.storefrontConfig?.catalog?.products?.additional_label?.text_color,
                    colorAttributeCode: metadata?.storefrontConfig?.catalog?.products?.additional_label?.color_attribute_code,
                    textColorAttributeCode: metadata?.storefrontConfig?.catalog?.products?.additional_label?.text_color_attribute_code
                },
                altImgSuffixAttributeCode: metadata?.storefrontConfig?.catalog?.products?.alt_img_suffix?.attribute_code,
                washingIcons: {
                    enabled: metadata?.storefrontConfig?.catalog?.products?.washing_icons?.enabled ?? false,
                    variant: metadata?.storefrontConfig?.catalog?.products?.washing_icons?.variant ?? 'tooltip',
                    attributeCode: metadata?.storefrontConfig?.catalog?.products?.washing_icons?.attribute_code ?? 'product_care'
                },
                additionalSalesAttributes: [],
                relatedSortAttributes: metadata?.storefrontConfig?.catalog?.products?.related_sort_attributes ?? []
            },
            categories: {
                heading: {
                    variant: metadata?.storefrontConfig?.catalog?.categories?.heading?.variant,
                    height: metadata?.storefrontConfig?.catalog?.categories?.heading?.height
                },
                showProductsCount: metadata?.storefrontConfig?.catalog?.categories?.show_products_count,
                filters: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.filters?.enabled,
                    maxToShow: metadata?.storefrontConfig?.catalog?.categories?.filters?.max_to_show,
                    showMoreButton: metadata?.storefrontConfig?.catalog?.categories?.filters?.show_more_button,
                    variant: metadata?.storefrontConfig?.catalog?.categories?.filters?.variant,
                    sidebarInitialOpened: metadata?.storefrontConfig?.catalog?.categories?.filters?.sidebar_initial_opened,
                    showProductsCount: {
                        parent: metadata?.storefrontConfig?.catalog?.categories?.filters?.show_product_count?.parent,
                        children: metadata?.storefrontConfig?.catalog?.categories?.filters?.show_product_count?.children
                    },
                    showHideFiltersButton: metadata?.storefrontConfig?.catalog?.categories?.filters?.show_hide_filter_button
                },
                sortBy: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.sort_by?.enabled
                },
                columnsDefault: metadata?.storefrontConfig?.catalog?.categories?.columns_default,
                columnsAlternate: metadata?.storefrontConfig?.catalog?.categories?.columns_alternate,
                viewMode: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.view_mode?.enabled
                },
                tileVariant: metadata?.storefrontConfig?.catalog?.categories?.tile_variant,
                infiniteScroll: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.infinite_scroll?.enabled,
                    showMore: metadata?.storefrontConfig?.catalog?.categories?.infinite_scroll?.show_more
                },
                pageSize: metadata?.storefrontConfig?.catalog?.categories?.products_per_page ?? 20,
                pagination: metadata?.storefrontConfig?.catalog?.categories?.pagination_mapping.map(({ page , productnumber , categoryids  })=>({
                        page,
                        pageSize: parseInt(productnumber),
                        categoryIds: (Array.isArray(categoryids) ? categoryids : [
                            categoryids
                        ]).map((id)=>isNaN(id) ? id : parseInt(id))
                    })) ?? [],
                ssr: {
                    childrenCategories: metadata?.storefrontConfig?.catalog?.categories?.ssr?.children_categories,
                    products: metadata?.storefrontConfig?.catalog?.categories?.ssr?.children_products,
                    configurableChildrenProducts: metadata?.storefrontConfig?.catalog?.categories?.ssr?.configurable_children_products,
                    groupedChildrenProducts: metadata?.storefrontConfig?.catalog?.categories?.ssr?.grouped_children_products,
                    bundleChildrenProducts: metadata?.storefrontConfig?.catalog?.categories?.ssr?.bundle_children_products,
                    siblingsCategories: metadata?.storefrontConfig?.catalog?.categories?.ssr?.siblings_categories ?? false,
                    ancestorsCategories: metadata?.storefrontConfig?.catalog?.categories?.ssr?.ancestors_categories ?? false
                },
                childrenCategories: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.children_categories?.enabled
                },
                altImgSuffixAttributeCode: metadata?.storefrontConfig?.catalog?.categories?.alt_img_suffix_attribute_code,
                macroCategories: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.enable_macro_categories
                },
                siblingsCategories: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.enable_siblings_categories ?? false
                },
                ancestorsCategories: {
                    enabled: metadata?.storefrontConfig?.catalog?.categories?.enable_ancestors_categories ?? false
                }
            },
            search: {
                showProductsCount: metadata?.storefrontConfig?.catalog?.search?.show_products_count,
                filters: {
                    enabled: metadata?.storefrontConfig?.catalog?.search?.filters?.enabled,
                    maxToShow: metadata?.storefrontConfig?.catalog?.search?.filters?.max_to_show,
                    showMoreButton: metadata?.storefrontConfig?.catalog?.search?.filters?.show_more_button,
                    variant: metadata?.storefrontConfig?.catalog?.search?.filters?.variant,
                    sidebarInitialOpened: metadata?.storefrontConfig?.catalog?.search?.filters?.sidebar_initial_opened,
                    showProductsCount: {
                        parent: metadata?.storefrontConfig?.catalog?.search?.filters?.product_count?.parent,
                        children: metadata?.storefrontConfig?.catalog?.search?.filters?.product_count?.children
                    },
                    showHideFiltersButton: metadata?.storefrontConfig?.catalog?.search?.filters?.show_hide_filter_button
                },
                sortBy: {
                    enabled: metadata?.storefrontConfig?.catalog?.search?.sort_by?.enabled
                },
                columnsDefault: metadata?.storefrontConfig?.catalog?.search?.columns_default,
                columnsAlternate: metadata?.storefrontConfig?.catalog?.search?.columns_alternate,
                viewMode: {
                    enabled: metadata?.storefrontConfig?.catalog?.search?.view_mode?.enabled
                },
                tileVariant: metadata?.storefrontConfig?.catalog?.search?.tile_variant,
                previewResultsLimit: metadata?.storefrontConfig?.search?.recommendations_limit,
                infiniteScroll: {
                    enabled: metadata?.storefrontConfig?.catalog?.search?.infinite_scroll?.enabled,
                    showMore: metadata?.storefrontConfig?.catalog?.search?.infinite_scroll?.show_more
                },
                pageSize: metadata?.storefrontConfig?.catalog?.categories?.products_per_page ?? 20,
                ssr: {
                    products: metadata?.storefrontConfig?.catalog?.search?.ssr?.products,
                    configurableChildrenProducts: metadata?.storefrontConfig?.catalog?.search?.ssr?.configurable_children_products,
                    groupedChildrenProducts: metadata?.storefrontConfig?.catalog?.search?.ssr?.grouped_children_products,
                    bundleChildrenProducts: metadata?.storefrontConfig?.catalog?.search?.ssr?.bundle_children_products
                },
                noResultsCmsBlockIdentifier: metadata?.storefrontConfig?.catalog?.search?.no_results_cms_block_identifier,
                externalService: {
                    enabled: metadata?.storefrontConfig?.catalog?.search?.externalService?.enabled ?? false,
                    adapter: metadata?.storefrontConfig?.catalog?.search?.external_service?.adapter ?? '',
                    apiUrl: metadata?.storefrontConfig?.catalog?.search?.external_service?.api_url
                },
                searchSuggestions: {
                    enabled: metadata?.storefrontConfig?.search?.search_suggestion_enabled ?? false
                }
            },
            disableShop: metadata?.storefrontConfig?.catalog?.disable_shop,
            hidePrice: metadata?.storefrontConfig?.catalog?.hide_price,
            swatches: {
                productPageAttributesProductImage: metadata?.storefrontConfig?.catalog?.swatches?.display_product_image_for_attributes_in_product_page,
                tileAttributesProductImage: metadata?.storefrontConfig?.catalog?.swatches?.display_product_image_for_attributes_in_tile
            },
            tileAttributesMapping: {
                title1: metadata?.storefrontConfig?.catalog?.tile_attribute_mapping?.title1,
                title2: metadata?.storefrontConfig?.catalog?.tile_attribute_mapping?.title2
            },
            globalCatalog: {
                enabled: metadata?.storefrontConfig?.catalog?.globalCatalog?.enabled ?? false,
                path: metadata?.storefrontConfig?.catalog?.globalCatalog?.path ?? 'global-catalog',
                name: metadata?.storefrontConfig?.catalog?.globalCatalog?.name ?? 'Global Catalog',
                rootCategoryLevel: metadata?.storefrontConfig?.catalog?.globalCatalog?.rootCategoryLevel ?? 2,
                seoMeta: {
                    description: metadata?.storefrontConfig?.catalog?.globalCatalog?.seoMeta?.description,
                    keywords: metadata?.storefrontConfig?.catalog?.globalCatalog?.seoMeta?.keywords || '',
                    robots: metadata?.storefrontConfig?.catalog?.globalCatalog?.seoMeta?.robots,
                    title: metadata?.storefrontConfig?.catalog?.globalCatalog?.seoMeta?.title
                }
            }
        },
        minicart: {
            noItemsBg: metadata?.storefrontConfig?.mini_cart?.no_items_background_image,
            productPageAutoOpen: metadata?.storefrontConfig?.mini_cart?.auto_open_after_add_to_cart
        },
        wishList: {
            enabled: metadata?.storefrontConfig?.wishlist?.general?.enabled ?? true,
            noItemsBg: metadata?.storefrontConfig?.wishlist?.no_items_background_image,
            shareable: metadata?.storefrontConfig?.wishlist?.shareable
        },
        newsletter: {
            enabled: metadata?.storefrontConfig?.newsletter?.enabled,
            popup: transformNewsletter(metadata?.storefrontConfig?.newsletter_popup)
        },
        defaultCountry: metadata?.storefrontConfig?.general?.default_country,
        allCountries: transformCountries(metadata?.configs?.all_countries_lookup),
        shippingCountries: transformCountries(metadata?.configs?.shipping_countries_lookup),
        disclaimers: {
            privacyPolicy: metadata?.storefrontConfig?.general?.disclaimers.privacy_policy,
            marketing: metadata?.storefrontConfig?.general?.disclaimers.marketing,
            checkout: {
                reassuranceInfo: {
                    enabled: metadata?.storefrontConfig?.sales?.reassurance_info?.enabled,
                    cmsBlockIdentifier: metadata?.storefrontConfig?.sales?.reassurance_info?.cms_block_identifier
                }
            },
            contacts: metadata?.storefrontConfig?.general?.disclaimers.contacts_form,
            workWithUs: metadata?.storefrontConfig?.general?.disclaimers.work_with_us_form,
            oosNotification: metadata?.storefrontConfig?.general?.disclaimers.out_of_stock_notification
        },
        copyright: metadata?.storefrontConfig?.general?.copyright,
        social: metadata?.storefrontConfig?.footer?.social,
        socialLogin: {
            facebook: {
                appId: metadata?.storefrontConfig?.social?.login.facebook_app_id
            },
            google: {
                clientId: metadata?.storefrontConfig?.social?.login.google_client_id
            },
            apple: {
                clientId: metadata?.storefrontConfig?.social?.login.apple_client_id
            }
        },
        socialShare: {
            enabled: metadata?.storefrontConfig?.social?.share?.enabled,
            socials: {
                facebook: metadata?.storefrontConfig?.social?.share?.facebook,
                twitter: metadata?.storefrontConfig?.social?.share?.twitter,
                pinterest: metadata?.storefrontConfig?.social?.share?.pinterest,
                whatsapp: metadata?.storefrontConfig?.social?.share?.whatsapp,
                // TODO: missing in the backend
                email: false
            }
        },
        multiDrawerMenu: {
            transition: metadata?.storefrontConfig?.multi_drawer_menu?.transition
        },
        dropdownMenu: {
            showOverlay: metadata?.storefrontConfig?.dropdown_menu?.show_overlay
        },
        blog: {
            enabled: metadata?.storefrontConfig?.static_pages?.blog?.enabled,
            path: metadata?.storefrontConfig?.static_pages?.blog?.path,
            breadcrumbs: metadata?.storefrontConfig?.static_pages?.blog?.breadcrumbs?.enabled,
            heading: metadata?.storefrontConfig?.static_pages?.blog?.heading?.enabled,
            ssr: metadata?.storefrontConfig?.static_pages?.blog?.ssr?.enabled,
            seoMeta: {
                title: metadata?.storefrontConfig?.static_pages?.blog?.seo_meta?.title,
                description: metadata?.storefrontConfig?.static_pages?.blog?.seo_meta?.description,
                robots: metadata?.storefrontConfig?.static_pages?.blog?.seo_meta?.robots,
                keywords: metadata?.storefrontConfig?.static_pages?.blog?.seo_meta?.keywords || ''
            },
            viewAllFilter: metadata?.storefrontConfig?.static_pages?.blog?.view_all_filter,
            cmsBlockIdentifierTop: metadata?.storefrontConfig?.static_pages?.blog?.cms_block_identifier_top,
            cmsBlockIdentifierBottom: metadata?.storefrontConfig?.static_pages?.blog?.cms_block_identifier_bottom,
            template: metadata?.storefrontConfig?.static_pages?.blog?.template,
            itemsPerPage: metadata?.storefrontConfig?.static_pages?.blog?.items_per_page,
            view: metadata?.storefrontConfig?.static_pages?.blog?.view,
            columns: metadata?.storefrontConfig?.static_pages?.blog?.columns
        },
        masterData: {
            ssr: metadata?.storefrontConfig?.master_data?.ssr
        },
        contacts: {
            enabled: metadata?.storefrontConfig?.static_pages?.contacts?.enabled,
            path: metadata?.storefrontConfig?.static_pages?.contacts?.path,
            reasons: metadata?.storefrontConfig?.static_pages?.contacts?.reasons,
            // TODO: missing configuration in the backend
            defaultReason: '',
            seoMeta: {
                title: metadata?.storefrontConfig?.static_pages?.contacts?.seo_meta?.title,
                description: metadata?.storefrontConfig?.static_pages?.contacts?.seo_meta?.description,
                robots: metadata?.storefrontConfig?.static_pages?.contacts?.seo_meta?.robots,
                keywords: metadata?.storefrontConfig?.static_pages?.contacts?.seo_meta?.keywords || ''
            },
            cmsBlockIdentifierTop: null,
            cmsBlockIdentifierBottom: null
        },
        workwithus: {
            enabled: metadata?.storefrontConfig?.static_pages?.work_with_us?.enabled,
            path: metadata?.storefrontConfig?.static_pages?.work_with_us?.path,
            jobArea: {
                enabled: metadata?.storefrontConfig?.static_pages?.job_area?.enabled,
                jobPositions: metadata?.storefrontConfig?.static_pages?.job_area?.job_positions?.map(({ label , value  })=>({
                        label,
                        value
                    })) ?? []
            },
            seoMeta: {
                title: metadata?.storefrontConfig?.static_pages?.work_with_us?.seo_meta?.title,
                description: metadata?.storefrontConfig?.static_pages?.work_with_us?.seo_meta?.description,
                robots: metadata?.storefrontConfig?.static_pages?.work_with_us?.seo_meta?.robots,
                keywords: metadata?.storefrontConfig?.static_pages?.work_with_us?.seo_meta?.keywords || ''
            }
        },
        quiz: {
            enabled: metadata?.storefrontConfig?.static_pages?.quiz?.enabled,
            path: metadata?.storefrontConfig?.static_pages?.quiz?.path,
            seoMeta: {
                title: metadata?.storefrontConfig?.static_pages?.quiz?.seo_meta?.title,
                description: metadata?.storefrontConfig?.static_pages?.quiz?.seo_meta?.description,
                robots: metadata?.storefrontConfig?.static_pages?.quiz?.seo_meta?.robots,
                keywords: metadata?.storefrontConfig?.static_pages?.quiz?.seo_meta?.keywords || ''
            }
        },
        stickyHeader: {
            enabled: metadata?.storefrontConfig?.sticky_header?.enabled,
            hideOnScrollDown: metadata?.storefrontConfig?.sticky_header?.hide_on_scroll_down
        },
        layout: {
            default: {
                headerType: metadata?.storefrontConfig?.layout?.default?.header_type,
                type: metadata?.storefrontConfig?.layout?.default?.type,
                headerVariant: metadata?.storefrontConfig?.layout?.default?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.default?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.default?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.default?.max_width_container
            },
            product: {
                type: metadata?.storefrontConfig?.layout?.product?.type,
                headerType: metadata?.storefrontConfig?.layout?.product?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.product?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.product?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.product?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.product?.max_width_container
            },
            category: {
                type: metadata?.storefrontConfig?.layout?.category?.type,
                headerType: metadata?.storefrontConfig?.layout?.category?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.category?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.category?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.category?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.category?.max_width_container
            },
            ['cms-page']: {
                type: metadata?.storefrontConfig?.layout?.cms_page?.type,
                headerType: metadata?.storefrontConfig?.layout?.cms_page?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.cms_page?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.cms_page?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.cms_page?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.cms_page?.max_width_container
            },
            master_data: {
                type: metadata?.storefrontConfig?.layout?.master_data?.type,
                headerType: metadata?.storefrontConfig?.layout?.master_data?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.master_data?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.master_data?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.master_data?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.master_data?.max_width_container
            },
            ['store-locator']: {
                type: metadata?.storefrontConfig?.layout?.store_locator?.type,
                headerType: metadata?.storefrontConfig?.layout?.store_locator?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.store_locator?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.store_locator?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.store_locator?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.store_locator?.max_width_container
            },
            ['store-locator-detail']: {
                type: metadata?.storefrontConfig?.layout?.store_locator_detail?.type,
                headerType: metadata?.storefrontConfig?.layout?.store_locator_detail?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.store_locator_detail?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.store_locator_detail?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.store_locator_detail?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.store_locator_detail?.max_width_container
            },
            contacts: {
                type: metadata?.storefrontConfig?.layout?.contacts?.type,
                headerType: metadata?.storefrontConfig?.layout?.contacts?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.contacts?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.contacts?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.contacts?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.contacts?.max_width_container,
                template: metadata?.storefrontConfig?.layout?.contacts?.template
            },
            quiz: {
                type: metadata?.storefrontConfig?.layout?.quiz?.type,
                headerType: metadata?.storefrontConfig?.layout?.quiz?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.quiz?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.quiz?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.quiz?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.quiz?.max_width_container
            },
            workwithus: {
                type: metadata?.storefrontConfig?.layout?.work_with_us?.type,
                headerType: metadata?.storefrontConfig?.layout?.work_with_us?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.work_with_us?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.work_with_us?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.work_with_us?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.work_with_us?.max_width_container
            },
            blog: {
                type: metadata?.storefrontConfig?.layout?.blog?.type,
                headerType: metadata?.storefrontConfig?.layout?.blog?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.blog?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.blog?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.blog?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.blog?.max_width_container
            },
            ['workwithus-advanced']: {
                footerVariant: metadata?.storefrontConfig?.layout?.workwithus_advanced?.footer_variant ?? 'four-rows',
                headerLook: metadata?.storefrontConfig?.layout?.workwithus_advanced?.header_look ?? 'light',
                headerType: metadata?.storefrontConfig?.layout?.workwithus_advanced?.header_type ?? 'filled',
                headerVariant: metadata?.storefrontConfig?.layout?.workwithus_advanced?.header_variant ?? 'compact',
                maxWidthContainer: metadata?.storefrontConfig?.layout?.workwithus_advanced?.max_width_container ?? 'xl',
                type: metadata?.storefrontConfig?.layout?.workwithus_advanced?.type ?? 'contained-boxed'
            },
            ['global-catalog']: {
                type: metadata?.storefrontConfig?.layout?.category?.type,
                headerType: metadata?.storefrontConfig?.layout?.category?.header_type,
                headerVariant: metadata?.storefrontConfig?.layout?.category?.header_variant,
                headerLook: metadata?.storefrontConfig?.layout?.category?.header_look,
                footerVariant: metadata?.storefrontConfig?.layout?.category?.footer_variant,
                maxWidthContainer: metadata?.storefrontConfig?.layout?.category?.max_width_container
            },
            breakpoints: {
                // TODO: missing in the backend
                // available breakpoints: xs, xsm, sm, md, lg, xl, xxl
                mobile: 'xs',
                desktop: 'lg'
            }
        },
        guestNestedLayout: {
            image: {
                src: metadata?.storefrontConfig?.layout?.guest_nested?.image?.src,
                width: metadata?.storefrontConfig?.layout?.guest_nested?.image?.width,
                height: metadata?.storefrontConfig?.layout?.guest_nested?.image?.height,
                alt: metadata?.storefrontConfig?.layout?.guest_nested?.image?.alt
            }
        },
        customerNestedLayout: {
            image: {
                src: metadata?.storefrontConfig?.layout?.customer_nested?.image?.src,
                width: metadata?.storefrontConfig?.layout?.customer_nested?.image?.width,
                height: metadata?.storefrontConfig?.layout?.customer_nested?.image?.height
            },
            sidebar: {
                title: metadata?.storefrontConfig?.layout?.customer_nested?.sidebar?.title,
                description: metadata?.storefrontConfig?.layout?.customer_nested?.sidebar?.description,
                email: metadata?.storefrontConfig?.layout?.customer_nested?.sidebar?.email
            }
        },
        customerCare: {
            enabled: metadata?.storefrontConfig?.customer_care?.enabled,
            path: metadata?.storefrontConfig?.customer_care?.path,
            customerCareNestedLayout: {
                image: {
                    src: metadata?.storefrontConfig?.layout?.customer_care_nested?.image?.src,
                    width: metadata?.storefrontConfig?.layout?.customer_care_nested?.image?.width,
                    height: metadata?.storefrontConfig?.layout?.customer_care_nested?.image?.height
                },
                menuIdentifier: metadata?.storefrontConfig?.layout?.customer_care_nested?.menu_identifier,
                search: {
                    enabled: metadata?.storefrontConfig?.layout?.customer_care_nested?.search?.enabled
                }
            }
        },
        salesAgentLayout: {
            image: {
                src: metadata?.storefrontConfig?.layout?.sales_agent?.image,
                width: metadata?.storefrontConfig?.layout?.sales_agent?.image_width,
                height: metadata?.storefrontConfig?.layout?.sales_agent?.image_height
            }
        },
        cms: {
            staticPath: metadata?.storefrontConfig?.content?.pages?.not_seo_friendly_urls
        },
        menus: metadata?.storefrontConfig?.content?.menus,
        manifest: {
            icons: {
                '96x96': metadata?.storefrontConfig?.general?.manifest?.icons['96x96'],
                '144x144': metadata?.storefrontConfig?.general?.manifest?.icons['144x144'],
                '192x192': metadata?.storefrontConfig?.general?.manifest?.icons['192x192'],
                '257x257': metadata?.storefrontConfig?.general?.manifest?.icons['257x257'],
                '384x384': metadata?.storefrontConfig?.general?.manifest?.icons['384x384'],
                '512x512': metadata?.storefrontConfig?.general?.manifest?.icons['512x512']
            }
        },
        richSnippets: {
            organization: {
                logo: metadata?.storefrontConfig?.rich_snippet?.organization?.logo || null
            },
            product: {
                brand: metadata?.storefrontConfig?.rich_snippet?.product?.brand || null
            }
        },
        rewardPoints: {
            enabled: metadata?.storefrontConfig?.customer?.reward_points?.is_enabled,
            uniqueUrl: metadata?.storefrontConfig?.customer?.reward_points?.unique_url_enable,
            enablePoints: metadata?.storefrontConfig?.customer?.reward_points?.enable_points ?? true,
            enableInvites: metadata?.storefrontConfig?.customer?.reward_points?.enable_invites ?? true
        },
        customer: {
            address: {
                autocomplete: {
                    enabled: metadata?.storefrontConfig?.general?.address_autocomplete?.enabled
                },
                streetRows: metadata?.storefrontConfig?.customer?.address?.street_rows,
                validation: {
                    cityLength: metadata?.storefrontConfig?.customer?.address_validation?.city_length,
                    firstnameLastnameSum: metadata?.storefrontConfig?.customer?.address_validation?.firstname_lastname_sum,
                    firstnameLength: metadata?.storefrontConfig?.customer?.address_validation?.firstname_length,
                    lastnameLength: metadata?.storefrontConfig?.customer?.address_validation?.lastname_length,
                    postcodeLength: metadata?.storefrontConfig?.customer?.address_validation?.postcode_length,
                    postcodeOptional: metadata?.storefrontConfig?.general?.optional_zip_countries,
                    regionLength: metadata?.storefrontConfig?.customer?.address_validation?.region_length,
                    streetLength: metadata?.storefrontConfig?.customer?.address_validation?.street_length,
                    careOfLength: metadata?.storefrontConfig?.customer?.address_validation?.care_of_length ?? 32
                },
                disclaimers: {
                    street: metadata?.storefrontConfig?.general?.disclaimers?.address?.street_additional_label
                },
                additionalFields: {
                    careOf: {
                        enabled: metadata?.storefrontConfig?.customer?.address?.fields?.care_of ?? false
                    }
                }
            },
            ordersPerPage: metadata?.storefrontConfig?.customer?.order?.rows_per_page,
            additionalConsents: {
                enabled: metadata?.storefrontConfig?.consents_manager?.enabled ?? false
            },
            register: {
                additionalFields: {
                    dob: {
                        // TODO: missing configuration in the backend
                        enabled: false,
                        required: false
                    }
                }
            }
        },
        restriction: {
            enabled: metadata?.storefrontConfig?.general?.restriction?.is_active,
            allowedPaths: metadata?.storefrontConfig?.general?.restriction?.allowed_path?.split(/(?:\n|,)+/) // split by newline or comma
            ?.filter((path)=>path !== '') || [],
            allowedPathsSalesAgentOnly: metadata?.storefrontConfig?.general?.restriction?.allowed_path_list_sales_agent_only?.split(/(?:\n|,)+/) // split by newline or comma
            ?.filter((path)=>path !== '') || [],
            mode: metadata?.storefrontConfig?.general?.restriction?.mode === 2 ? 'login-register' : 'login-only'
        },
        trackings: [
            {
                id: 'dummy',
                enabled: metadata?.storefrontConfig?.dummy?.enabled
            },
            {
                id: 'gtm',
                enabled: metadata?.storefrontConfig?.google_tag_manager?.enabled,
                code: metadata?.storefrontConfig?.google_tag_manager?.code,
                auth: metadata?.storefrontConfig?.google_tag_manager?.auth,
                preview: metadata?.storefrontConfig?.google_tag_manager?.preview,
                file_url: metadata?.storefrontConfig?.google_tag_manager?.file_url
            },
            {
                id: 'gtm-ga4',
                enabled: metadata?.storefrontConfig?.trackings?.ga4?.enabled,
                code: metadata?.storefrontConfig?.trackings?.ga4?.code,
                auth: metadata?.storefrontConfig?.trackings?.ga4?.auth,
                preview: metadata?.storefrontConfig?.trackings?.ga4?.preview,
                file_url: metadata?.storefrontConfig?.trackings?.ga4?.file_url
            },
            {
                id: 'clerk',
                enabled: metadata?.storefrontConfig?.catalog?.clerk?.enabled,
                code: metadata?.storefrontConfig?.catalog?.clerk?.api_key,
                apiUrl: metadata?.storefrontConfig?.catalog?.clerk?.api_url
            },
            {
                id: 'bh-search',
                enabled: metadata?.storefrontConfig?.trackings?.bh_search?.enabled
            },
            {
                id: 'bh-list-context',
                enabled: metadata?.storefrontConfig?.trackings?.bh_tracking?.enabled ?? true
            },
            {
                id: 'sizebay',
                enabled: metadata?.storefrontConfig?.trackings?.sizebay?.enabled
            }
        ],
        whatsapp: {
            enabled: metadata?.storefrontConfig?.general?.whatsapp?.enabled,
            number: metadata?.storefrontConfig?.general?.whatsapp?.number,
            prefilled: metadata?.storefrontConfig?.general?.whatsapp?.prefilled
        },
        zendesk: {
            enabled: metadata?.storefrontConfig?.general?.zendesk?.enabled,
            scriptSrc: metadata?.storefrontConfig?.general?.zendesk?.script_src,
            departments: metadata?.storefrontConfig?.zendesk?.departments?.map((department)=>department.code) ?? [],
            preselectedDepartment: metadata?.storefrontConfig?.zendesk?.preselected_department
        },
        amazonConnectChat: {
            enabled: metadata?.storefrontConfig?.general?.amazon_connect_chat?.enabled,
            widgetId: metadata?.storefrontConfig?.general?.amazon_connect_chat?.widget_id,
            scriptUrl: metadata?.storefrontConfig?.general?.amazon_connect_chat?.script_url,
            snippetId: metadata?.storefrontConfig?.general?.amazon_connect_chat?.snippet_id
        },
        amazonConnectChatCustom: {
            enabled: metadata?.storefrontConfig?.general?.amazon_connect_chat?.enabled
        },
        floatingActions: {
            position: metadata?.storefrontConfig?.layout?.floating_actions?.position,
            top: metadata?.storefrontConfig?.layout?.floating_actions?.top,
            singleWidget: metadata?.storefrontConfig?.layout?.floating_actions?.single_widget ?? false
        },
        rma: {
            enabled: metadata?.storefrontConfig?.sales?.rma?.enabled,
            cmsBlockIdentifier: metadata?.storefrontConfig?.sales?.rma?.easy_return?.general_description_cms_block_identifier,
            normal: {
                cmsBlockIdentifier: metadata?.storefrontConfig?.sales?.rma?.easy_return?.normal_rma_description_cms_block_identifier
            },
            easy: {
                enabled: metadata?.storefrontConfig?.sales?.rma?.easy_return?.enabled,
                cmsBlockIdentifier: metadata?.storefrontConfig?.sales?.rma?.easy_return?.easy_rma_description_cms_block_identifier
            }
        },
        notifyMessage: {
            enabled: metadata?.storefrontConfig?.layout?.notify_message?.enabled,
            cmsBlockIdentifier: metadata?.storefrontConfig?.layout?.notify_message?.cms_block_identifier,
            cmsBlockIdentifierAdditionalContent: metadata?.storefrontConfig?.layout?.notify_message?.additional_content_cms_block_identifier,
            position: metadata?.storefrontConfig?.layout?.notify_message?.position,
            closeEnabled: metadata?.storefrontConfig?.layout?.notify_message?.close_enabled
        },
        clerk: {
            enabled: metadata?.storefrontConfig?.catalog?.clerk?.enabled,
            apiKey: metadata?.storefrontConfig?.catalog?.clerk?.api_key,
            recommendationsApiUrl: metadata?.storefrontConfig?.catalog?.clerk?.recommendations_api_url,
            liveSearch: {
                categories: metadata?.storefrontConfig?.catalog?.clerk?.livesearch_categories ?? '0',
                dropdownPosition: metadata?.storefrontConfig?.catalog?.clerk?.livesearch_dropdown_position || 'off',
                enabled: metadata?.storefrontConfig?.catalog?.clerk?.livesearch_enabled ?? false,
                // formSelector: clerkConfigs.livesearch_form_selector, // NOTE: not used
                includeCategories: metadata?.storefrontConfig?.catalog?.clerk?.livesearch_include_categories,
                // inputSelector: clerkConfigs.livesearch_input_selector, // NOTE: not used
                pages: metadata?.storefrontConfig?.catalog?.clerk?.livesearch_pages ?? '0',
                // pagesType: clerkConfigs.livesearch_pages_type, // NOTE: not used
                suggestions: metadata?.storefrontConfig?.catalog?.clerk?.livesearch_suggestions ?? '0',
                template: `@${metadata?.storefrontConfig?.catalog?.clerk?.livesearch_template ?? 'live-search'}`
            },
            search: {
                categories: metadata?.storefrontConfig?.catalog?.clerk?.search_categories ?? '0',
                enabled: metadata?.storefrontConfig?.catalog?.clerk?.search_enabled ?? false,
                includeCategories: metadata?.storefrontConfig?.catalog?.clerk?.search_include_categories ?? false,
                // loadMoreText: metadata?.storefrontConfig?.catalog?.clerk?.search_load_more_text,
                // noResultsText: metadata?.storefrontConfig?.catalog?.clerk?.search_no_results_text,
                pages: metadata?.storefrontConfig?.catalog?.clerk?.search_pages ?? '0',
                // pagesType: clerkConfigs.search_pages_type, // NOTE: not used
                sortByAllowed: metadata?.storefrontConfig?.catalog?.clerk?.search_sort_by_allowed ?? {},
                sortByEnabled: metadata?.storefrontConfig?.catalog?.clerk?.search_sort_by_enabled ?? false,
                template: `@${metadata?.storefrontConfig?.catalog?.clerk?.search_template ?? 'search-page'}`
            },
            facetedSearch: {
                // filters
                attributes: transformClerkAttributes({
                    facetsAttributes: metadata?.storefrontConfig?.catalog?.clerk?.faceted_search_attributes,
                    titles: transformClerkTitles({
                        facetsTitles: metadata?.storefrontConfig?.catalog?.clerk?.faceted_search_titles || '{}'
                    })
                }),
                enabled: metadata?.storefrontConfig?.catalog?.clerk?.faceted_search_enabled ?? false,
                design: metadata?.storefrontConfig?.catalog?.clerk?.faceted_search_design,
                multiselectAttributes: JSON.stringify(metadata?.storefrontConfig?.catalog?.clerk?.faceted_search_multiselect_attributes?.split(',') || []),
                titles: transformClerkTitles({
                    facetsTitles: metadata?.storefrontConfig?.catalog?.clerk?.faceted_search_titles || '{}'
                })
            }
        },
        apiRegExpNoCacheHeaders: '.*(?:/account/|/crm/|/sales/|/session/|/auth/|/alert/|/pos/|/amazon/connectchat/).*',
        workwithusAdvanced: {
            enabled: metadata?.storefrontConfig?.static_pages?.workwithus_advanced?.enabled ?? false,
            paginationEnabled: metadata?.storefrontConfig?.static_pages?.workwithus_advanced?.pagination_enabled ?? true,
            path: metadata?.storefrontConfig?.static_pages?.workwithus_advanced?.path ?? '/work-with-us-advanced',
            seoMeta: {
                title: metadata?.storefrontConfig?.static_pages?.workwithus_advanced?.seo_meta?.title,
                description: metadata?.storefrontConfig?.static_pages?.workwithus_advanced?.seo_meta?.description,
                robots: metadata?.storefrontConfig?.static_pages?.workwithus_advanced?.seo_meta?.robots,
                keywords: metadata?.storefrontConfig?.static_pages?.workwithus_advanced?.seo_meta?.keywords || ''
            }
        },
        sizebay: {
            enabled: metadata?.storefrontConfig?.catalog?.sizebay?.enabled ?? false,
            scriptSrc: metadata?.storefrontConfig?.catalog?.sizebay?.script_src ?? 'https://vfr-v3-production.sizebay.technology/V4/implantation/index.js',
            cssSrc: metadata?.storefrontConfig?.catalog?.sizebay?.css_src ?? 'https://static.sizebay.technology/{tenantId}/styles_v4.css',
            tenantId: metadata?.storefrontConfig?.catalog?.sizebay?.tenant_id,
            enabledFindSize: metadata?.storefrontConfig?.catalog?.sizebay?.enabled_find_size ?? true,
            enabledSizeGuide: metadata?.storefrontConfig?.catalog?.sizebay?.enabled_size_guide ?? true
        },
        security: {
            csp: {
                enabled: metadata?.storefrontConfig?.csp?.enabled,
                reportOnly: metadata?.storefrontConfig?.csp?.reportOnly,
                report: {
                    enabled: metadata?.storefrontConfig?.csp?.report?.enabled,
                    reportUri: metadata?.storefrontConfig?.csp?.report?.reportUri,
                    reportTo: {
                        code: metadata?.storefrontConfig?.csp?.report?.reportTo?.code,
                        configData: metadata?.storefrontConfig?.security?.csp?.report?.reportTo?.configData
                    }
                },
                rules: metadata?.storefrontConfig?.csp?.rules,
                rulesCustom: metadata?.storefrontConfig?.csp?.rulesCustom
            }
        },
        projectSpecific: metadata?.storefrontConfig?.projectSpecific || {},
        salesAgent: {
            enabled: metadata?.storefrontConfig?.sales_agent?.general?.enabled ?? false,
            canViewCheckout: metadata?.storefrontConfig?.sales_agent?.general?.can_view_checkout ?? false,
            ordersPerPage: metadata?.storefrontConfig?.sales_agent?.general?.orders_per_page ?? 5,
            quotes: {
                enabled: metadata?.storefrontConfig?.sales_agent?.quotes?.enabled ?? false,
                quotesPerPage: metadata?.storefrontConfig?.sales_agent?.quotes?.quotes_per_page ?? 5,
                dashboard: {
                    quotesPerPage: metadata?.storefrontConfig?.sales_agent?.quotes?.dashboard_quotes_per_page ?? 5
                },
                create: {
                    description: {
                        required: metadata?.storefrontConfig?.sales_agent?.quotes?.create_field_description_required ?? false,
                        enabled: metadata?.storefrontConfig?.sales_agent?.quotes?.create_field_description_enabled ?? true
                    },
                    additionalDescription: {
                        required: metadata?.storefrontConfig?.sales_agent?.quotes?.create_additional_description_required ?? false,
                        enabled: metadata?.storefrontConfig?.sales_agent?.quotes?.create_additional_description_enabled ?? true
                    }
                }
            },
            clients: {
                enabled: metadata?.storefrontConfig?.sales_agent?.clients?.enabled ?? false,
                clientsPerPage: metadata?.storefrontConfig?.sales_agent?.clients?.clients_per_page ?? 5
            },
            customer: {
                quotesPerPage: metadata?.storefrontConfig?.sales_agent?.customer?.quotesPerPage ?? 6,
                salesAgentListEnabled: metadata?.storefrontConfig?.sales_agent?.clients?.sales_agent_list_enabled ?? false,
                salesAgentPerPage: metadata?.storefrontConfig?.sales_agent?.customer?.sales_agent_per_page ?? 6
            }
        },
        omnibus: {
            enabled: metadata?.storefrontConfig?.omnibus?.enabled ?? false,
            apiUrl: metadata?.storefrontConfig?.omnibus?.api_url ?? 'https://omnibus.filoblu.com',
            brand: metadata?.storefrontConfig?.omnibus?.brand ?? ''
        },
        partnerProgram: {
            enabled: metadata?.storefrontConfig?.filoblu?.partner_program?.enabled ?? false,
            formFields: transformPartnerProgramFormFields(metadata?.storefrontConfig?.filoblu?.partner_program?.form_fields ?? {}),
            privacyPolicy: {
                privacyPolicy: metadata?.storefrontConfig?.filoblu?.partner_program?.privacy_policy?.privacy_policy,
                marketingPolicyEnabled: metadata?.storefrontConfig?.filoblu?.partner_program?.privacy_policy?.marketing_policy_enabled,
                marketingPolicyRequired: metadata?.storefrontConfig?.filoblu?.partner_program?.privacy_policy?.marketing_policy_required,
                marketingPolicy: metadata?.storefrontConfig?.filoblu?.partner_program?.privacy_policy?.marketing_policy
            }
        },
        // TODO: missing config backend -> metadata.storefrontConfig.seo
        seoMarkup: {
            name: undefined,
            alternateName: undefined,
            email: undefined,
            sameAs: undefined,
            streetAddress: undefined,
            addressLocality: undefined,
            addressRegion: undefined,
            postalCode: undefined,
            addressCountry: undefined,
            vatID: undefined
        }
    } : {};

export { transformCoreStoresLanguages, transformCoreStoresResponse, transformCoreStoresStore };
